<template>
  <div class="_rfp_mctb_list_10_ rfp-mctb-product-list-row">
    <div
      v-for="lists in productListJson.Products"
      :key="lists.RatingText"
      class="_rfp_mctb_list_11_ rfp-mctb-product-list-column"
    >
      <div class="_rfp_mctb_list_12_ rfp-mctb-product-list-card">
        <img
          v-if="!lists.HideImage"
          class="_rfp_mctb_list_13_"
          :src="lists.Image"
          :alt="lists.ImageAlt"
          style="width: 100%"
          @click="redirectPdpUrl(lists.Url)"
        />
        <div
          v-if="!lists.HideTitle"
          class="_rfp_mctb_list_14_ rfp-mctb-product-list-product-title"
          :class="{ 'rfp-mctb-star-rating-url-redirect': productListJson.PDPRedirectOn }"
          @click="redirectPdpUrl(lists.Url)"
          v-html="lists.Title"
        ></div>
        <p v-if="!lists.HideDescription" class="_rfp_mctb_list_15_" v-html="lists.Description"></p>
        <div v-if="!lists.HideReview" class="_rfp_mctb_list_15_ rfp-mctb-star-rating-header">
          <rfp-mctb-star-ratings
            class="rfp-mctb-star-rating-header-star"
            :increment="1"
            :max-rating="5"
            :inactive-color="starInactiveColor"
            :active-color="starActiveColor"
            :star-size="starSize"
            :read-only="true"
            :rating="convertToNumber(lists.AverageReviews)"
            :show-rating="false"
          >
          </rfp-mctb-star-ratings>
          <div class="rfp-mctb-star-rating-header-star-reviews">{{ lists.RatingText }}</div>
        </div>
        <p class="_rfp_mctb_list_16_">
          <rfp-mctb-main-container
            :retailer-unavailable="retailerUnavailable"
            :buy-now="buyNow"
            :carousel-header="carouselHeader"
            :data="{
              Display: productListJson.Display,
              Action: productListJson.Action,
              ScanToBuyRedirect: { EnableScanToBuyRedirect: false, ScanToBuyQuerystringName: 't' },
              Product: lists,
              CountryList: productListJson.CountryList,
            }"
            :buy-online-button-text="buyOnlineButtonText"
            :buy-offline-button-text="buyOfflineButtonText"
            :enable-rtl="enableRtl"
            :sport-lite-mode="true"
            :component-diffs="componentDiffs"
          >
          </rfp-mctb-main-container>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import RfpMctbStarRatings from '../rfp-mctb-star-ratings/rfp-mctb-star-ratings.vue';
import RfpMctbMainContainer from '../rfp-mctb-main-container.vue';

export default {
  name: 'rfp-mctb-product-list',
  components: {
    RfpMctbStarRatings,
    RfpMctbMainContainer,
  },
  props: {
    productListJson: {
      type: Object,
      required: false,
    },
    buyOnlineButtonText: {
      type: String,
      default: 'Online',
    },
    buyOfflineButtonText: {
      type: String,
      default: 'Offline',
    },
    carouselHeader: {
      type: String,
      required: false,
    },
    buyNow: {
      type: String,
      required: false,
    },
    starInactiveColor: {
      type: String,
      default: '#000',
    },
    starActiveColor: {
      type: String,
      default: '#f00',
    },
    starSize: {
      type: Number,
      default: 25,
    },
    enableRtl: {
      type: Boolean,
      default: false,
    },
    componentDiffs: {
      type: Boolean,
      default: false,
    },
    retailerUnavailable: {
      type: String,
      default: 'unfortunatly no retailers are available at this moment.',
    },
  },
  data() {
    return {};
  },
  methods: {
    convertToNumber(val) {
      return parseInt(val); // eslint-disable-line
    },
    redirectPdpUrl(pdpUrl) {
      if (this.productListJson.PDPRedirectOn) {
        window.location.href = pdpUrl;
      }
    },
  },
};
</script>
